import { queryClient } from "@/services/queryClient";
import { useAppSelector } from "@/store/hooks";
import { useEffect } from "react";

export function useAdvertisementSSE() {
  const { user } = useAppSelector((state) => state.auth);

  const userId = user?.id ?? "";

  useEffect(() => {
    const url = `${import.meta.env.VITE_API_BASE_URL}/advertisement/stream`;

    console.log("[Advertisement SSE] Connecting:", url);

    const es = new EventSource(url, {
      withCredentials: true,
    });

    es.onopen = () => {
      console.log("[Advertisement SSE] Connected");
    };

    es.onmessage = (event) => {
      console.log("[Advertisement SSE] Message received:", event);

      try {
        const realtimeEvent = JSON.parse(event.data);

        console.log("[Advertisement SSE] Parsed event:", realtimeEvent);

        switch (realtimeEvent.type) {
          case "created":
          case "updated":
          case "paused":
          case "activated":
          case "closed":
            queryClient.invalidateQueries({
              queryKey: ["advertisments:all"],
            });

            queryClient.invalidateQueries({
              queryKey: ["advertisements"],
            });

            /*
             * Merchant's own ads.
             */
            queryClient.invalidateQueries({
              queryKey: ["profile", userId],
            });

            break;

          case "liquidity.updated":
            queryClient.invalidateQueries({
              queryKey: ["ads"],
            });

            if (realtimeEvent.adId) {
              queryClient.invalidateQueries({
                queryKey: ["ad", realtimeEvent.adId],
              });
            }

            break;

          default:
            console.warn("[Advertisement SSE] Unknown event:", realtimeEvent);
        }
      } catch (error) {
        console.error("[Advertisement SSE] Failed to parse event:", error);
      }
    };

    es.onerror = (error) => {
      console.error("[Advertisement SSE] Connection error:", error);
    };

    return () => {
      console.log("[Advertisement SSE] Closing connection");
      es.close();
    };
  }, [userId]);
}
